"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.storefrontVisited = void 0;
var constants_1 = require("../constants");
exports.storefrontVisited = function (_a) {
    var _b;
    var session = _a.session, storefront = _a.storefront;
    var props = (_b = {},
        _b[constants_1.EventProperty.CURRENCY] = storefront.currency,
        _b[constants_1.EventProperty.USER_ID] = session.userID,
        _b[constants_1.EventProperty.CUSTOMER_NAME] = session.customer,
        _b);
    window.analytics.page(constants_1.EventName.STOREFRONT_VISITED, props);
};
